// Simple logger: skips `debug` logs in production, logs all levels in development.
const isProd = process.env.NODE_ENV === 'production';

const color = {
    debug: '\x1b[36m',
    info: '\x1b[32m',
    warn: '\x1b[33m',
    error: '\x1b[31m',
    reset: '\x1b[0m',
};

const log = (level: 'debug' | 'info' | 'warn' | 'error', msg: string, ...params: any[]) => {
    if (isProd && level === 'debug') return;

    const time = new Date().toISOString();
    const prefix = isProd
        ? `[${level.toUpperCase()}] ${time} -`
        : `${color[level]}[${level.toUpperCase()}]${color.reset} ${time} -`;

    const consoleMethod = level === 'debug' ? console.log : console[level];

    consoleMethod(prefix, msg, ...params);
};

export const logger = {
    debug: (msg: string, ...params: any[]) => log('debug', msg, ...params),
    info: (msg: string, ...params: any[]) => log('info', msg, ...params),
    warn: (msg: string, ...params: any[]) => log('warn', msg, ...params),
    error: (msg: string, ...params: any[]) => log('error', msg, ...params),
};
